import { FloatingEditButton } from 'content-stack/components/FloatingEditButton/FloatingEditButton'
import { LabelsProvider } from 'labels/context/LabelsProvider/LabelsProvider'
import { LayoutMasterDataProvider } from 'master-data/contexts/LayoutMasterDataProvider/LayoutMasterDataProvider'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useEffect } from 'react'
import { createRoot } from 'react-dom/client'

export function useContentstackEditOverlay(isInitialized: boolean) {
	const masterData = useMasterData()
	useEffect(() => {
		if (!isInitialized) {
			return undefined
		}

		let currentTarget: HTMLElement | null = null

		const removeOverlay = () => {
			if (!currentTarget) {
				return
			}

			const button = currentTarget.querySelector('[data-current-cslp]')
			if (button) {
				button.remove()
			}

			currentTarget.style.outline = ''
			currentTarget = null
		}

		const handleMouseEnter = (e: MouseEvent) => {
			const target = e.target
			if (!(target instanceof Element)) {
				return
			}

			const cslpElement = target.closest('[data-cslp]') as HTMLElement
			if (!cslpElement || cslpElement === currentTarget) {
				return
			}

			removeOverlay()

			const currentCslp = cslpElement.getAttribute('data-cslp') ?? ''
			const buttonContainer = document.createElement('div')
			const root = createRoot(buttonContainer)
			root.render(
				<LayoutMasterDataProvider masterData={masterData}>
					<LabelsProvider labels={{}} locale='en-GB'>
						<FloatingEditButton currentCslp={currentCslp} />
					</LabelsProvider>
				</LayoutMasterDataProvider>
			)

			if (getComputedStyle(cslpElement).position === 'static') {
				cslpElement.style.position = 'relative'
			}

			cslpElement.appendChild(buttonContainer)
			cslpElement.style.outline = '1px dashed #ff4c4c'
			currentTarget = cslpElement
		}

		document.addEventListener('mouseenter', handleMouseEnter, true)
		window.addEventListener('scroll', removeOverlay, { passive: true })

		return () => {
			document.removeEventListener('mouseenter', handleMouseEnter, true)
			window.removeEventListener('scroll', removeOverlay)
		}
	}, [isInitialized])
}
